import { IOcojoImageSource } from "../../domain/ocojo";

export interface IOcojoImageStockable {
  getStockedOcojoImage(patientId: string, imageId: string): IOcojoImageSource;
}

export function instanceOfIOcojoImageStockable(instance: any): instance is IOcojoImageStockable {
  return instance
    && (instance.getStockedOcojoImage !== undefined);
}
